import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FunctionService } from '../../services/function.service';

@Component({
  selector: 'app-system',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule],
  templateUrl: './system.component.html',
  styleUrl: './system.component.css'
})
export class SystemComponent {
  constructor(public functionService: FunctionService) {}

  // Elenco delle card di sistema (le stesse chiavi usate nei *ngIf)
  private readonly systemFeatures = [
    'webhook-management',
    'data-exchange-management',
    'otm-management',
    'eod-report',
    'pdf-management',
    'waybill-example',
    'print-documents',
    'barcode-generator',
    'dealer-massive-insert',
    'system-monitoring',
    'zone-region'
  ];

  hasVisibleCards = false;

  ngOnInit(): void {
    this.hasVisibleCards = this.systemFeatures.some(f =>
      this.functionService.canRead(f)
    );
  }
}
